import classNames from 'classnames'
import Link from 'next/link'
import { Fragment } from 'react'
import { NamedEntity } from 'types'
import { getArtistUrl } from 'utils/urls'

type Props = {
  artists: NamedEntity[]
  textColor?: string
  className?: string
  textClassName?: string
  clickable?: boolean
}

export const ArtworkArtistsNames = ({
  artists,
  textColor = 'text-cool-600',
  textClassName,
  clickable = true,
  className,
}: Props) => {
  const _textClassName = classNames(
    'text-sm',
    textColor,
    textClassName,
    clickable && 'hover:text-secondary-default'
  )

  return (
    <div
      className={classNames(
        'flex space-x-1 overflow-hidden overflow-ellipsis whitespace-nowrap',
        className
      )}
    >
      {artists?.map((artist, index) => (
        <Fragment key={artist.id}>
          {clickable ? (
            <Link
              href={getArtistUrl(artist.name, artist.id)}
              className={_textClassName}
            >
              {artist.name}
            </Link>
          ) : (
            <span className={_textClassName}>{artist.name}</span>
          )}

          {artists[index + 1] && (
            <span className={`text-sm ${textColor} ${textClassName}`}>x</span>
          )}
        </Fragment>
      ))}
    </div>
  )
}
